import React, { memo } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "components/Shared";
import { isOpenPropertyRow, SlaPropertyRow } from "../types";

interface Props {
  row: SlaPropertyRow;
}

// api-contract §5.2/§5.3 — the lifecycle is inferred directly from the row's
// own shape via `isOpenPropertyRow` (an open row carries `upcoming_count`;
// a completed row carries `ahead_count`/`on_time_count`). All rows within a
// single `properties` array share the same lifecycle as the sibling summary.
const PropertyPerformanceRow = ({ row }: Props) => {
  const history = useHistory();

  return (
    <div className="flex items-center justify-between py-3 px-4 border-b border-black-10 hover:bg-black-5">
      <div className="flex-1 min-w-0">
        <div className="text-14 font-semibold text-black-80">{row.property_name}</div>
        {row.property_locality && (
          <div className="text-12 text-black-60">{row.property_locality}</div>
        )}
      </div>

      <div className="flex items-center gap-5 ml-4 flex-shrink-0 text-13">
        {isOpenPropertyRow(row) ? (
          <div className="text-center">
            <div className="font-semibold text-primary">{row.upcoming_count}</div>
            <div className="text-11 text-black-40">Upcoming</div>
          </div>
        ) : (
          <>
            <div className="text-center">
              <div className="font-semibold text-primary">{row.ahead_count}</div>
              <div className="text-11 text-black-40">Ahead</div>
            </div>
            <div className="text-center">
              <div className="font-semibold text-primary">{row.on_time_count}</div>
              <div className="text-11 text-black-40">On Time</div>
            </div>
          </>
        )}
        <div className="text-center">
          <div className="font-semibold text-warning-darker">{row.at_risk_count}</div>
          <div className="text-11 text-black-40">At Risk</div>
        </div>
        <div className="text-center">
          <div className="font-semibold text-error-darker">{row.breached_count}</div>
          <div className="text-11 text-black-40">Breached</div>
        </div>
        <Button
          onClick={() => history.push(`/sla-monitor/properties/${row.property_id}`)}
        >
          View Details
        </Button>
      </div>
    </div>
  );
};

export default memo(PropertyPerformanceRow);
